import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import { IconLoader2 } from '@tabler/icons-react';
import { useIntl } from 'react-intl';
import { useSelector } from 'store';

const ICON_PX = 18;

/** מסתנכרן עם Template Watcher — מוצג ליד סטטוס Axios הגלובלי */
export default function TemplateWatcherSyncIndicator() {
  const theme = useTheme();
  const intl = useIntl();
  const syncing = useSelector((s) => s.templateWatcher.isSyncing);

  const ariaLabel = intl.formatMessage({ id: 'logoSection.templateWatcherSyncingTooltip' });

  return (
    <Tooltip title={ariaLabel} disableHoverListener={!syncing}>
      <Box
        component="span"
        role={syncing ? 'status' : undefined}
        aria-live={syncing ? 'polite' : undefined}
        aria-busy={syncing}
        aria-label={syncing ? ariaLabel : undefined}
        aria-hidden={!syncing}
        sx={{
          position: 'relative',
          width: ICON_PX,
          height: ICON_PX,
          minWidth: ICON_PX,
          minHeight: ICON_PX,
          flexShrink: 0,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginInlineStart: 1,
          color: syncing ? theme.palette.secondary.main : 'transparent',
          cursor: 'default',
          visibility: syncing ? 'visible' : 'hidden',
          '@keyframes templateWatcherSpin': {
            '0%': { transform: 'rotate(0deg)' },
            '100%': { transform: 'rotate(360deg)' },
          },
          ...(syncing && {
            animation: 'templateWatcherSpin 0.85s linear infinite',
          }),
        }}
      >
        <IconLoader2 stroke={1.75} size={ICON_PX} aria-hidden />
      </Box>
    </Tooltip>
  );
}
